import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomeOne from './pages/homepages/HomeOne';
import HomeTwo from './pages/homepages/HomeTwo';
import HomeThree from './pages/homepages/HomeThree';
import HomeFour from './pages/homepages/HomeFour';
import AboutUsOne from './pages/innerpages/AboutUsOne';
import AboutUsTwo from './pages/innerpages/AboutUsTwo';
import AboutUsThree from './pages/innerpages/AboutUsThree';
import ContactUsOne from './pages/innerpages/ContactUsOne';
import ContactUsTwo from './pages/innerpages/ContactUsTwo';
import ContactUsThree from './pages/innerpages/ContactUsThree';
import AttorneyFullWidthOne from './pages/attorneypages/AttorneyFullWidthOne';
import AttorneyLeftSidebarThreeGridOne from './pages/attorneypages/AttorneyLeftSidebarThreeGridOne';
import AttorneyLeftSidebarTwoGridOne from './pages/attorneypages/AttorneyLeftSidebarTwoGridOne';
import AttorneyRightSidebarThreeGridOne from './pages/attorneypages/AttorneyRightSidebarThreeGridOne';
import AttorneyRightSidebarTwoGridOne from './pages/attorneypages/AttorneyRightSidebarTwoGridOne';
import AttorneySingleOne from './pages/attorneypages/AttorneySingleOne';
import AttorneySingleTwo from './pages/attorneypages/AttorneySingleTwo';
import PracticeFullWidthOne from './pages/practicepages/PracticeFullWidthOne';
import PracticeLeftSidebarTwoGridOne from './pages/practicepages/PracticeLeftSidebarTwoGridOne';
import PracticeRightSidebarTwoGridOne from './pages/practicepages/PracticeRightSidebarTwoGridOne';
import PracticeSingleOne from './pages/practicepages/PracticeSingleOne';
import PracticeSingleTwo from './pages/practicepages/PracticeSingleTwo';
import BlogFullWidthOne from './pages/blogpages/BlogFullWidthOne';
import BlogLeftSidebarTwoGridOne from './pages/blogpages/BlogLeftSidebarTwoGridOne';
import BlogRightSidebarTwoGridOne from './pages/blogpages/BlogRightSidebarTwoGridOne';
import BlogSingleOne from './pages/blogpages/BlogSingleOne';
import BlogSingleTwo from './pages/blogpages/BlogSingleTwo';
import Error from './pages/innerpages/Error';


function App() {
  return (
    <Router>
        <Routes>
          <Route exact path='/' element={<HomeOne/>}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-2'}`} element={<HomeTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-3'}`} element={<HomeThree />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-4'}`} element={<HomeFour />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/home-4'}`} element={<HomeFour />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/about-us-1'}`} element={<AboutUsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/about-us-2'}`} element={<AboutUsTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/about-us-3'}`} element={<AboutUsThree />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/contact-us-1'}`} element={<ContactUsOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/contact-us-2'}`} element={<ContactUsTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/contact-us-3'}`} element={<ContactUsThree />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-full-width-1'}`} element={<AttorneyFullWidthOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-left-sidebar-three-grid-1'}`} element={<AttorneyLeftSidebarThreeGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-left-sidebar-two-grid-1'}`} element={<AttorneyLeftSidebarTwoGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-right-sidebar-three-grid-1'}`} element={<AttorneyRightSidebarThreeGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-right-sidebar-two-grid-1'}`} element={<AttorneyRightSidebarTwoGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-single-1'}`} element={<AttorneySingleOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/attorney-single-2'}`} element={<AttorneySingleTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/practice'}`} element={<PracticeFullWidthOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/practice-left-sidebar'}`} element={<PracticeLeftSidebarTwoGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/practice-right-sidebar'}`} element={<PracticeRightSidebarTwoGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/practice-single-left-sidebar'}`} element={<PracticeSingleOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/practice-single-right-sidebar'}`} element={<PracticeSingleTwo />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog'}`} element={<BlogFullWidthOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-left-sidebar'}`} element={<BlogLeftSidebarTwoGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-right-sidebar'}`} element={<BlogRightSidebarTwoGridOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-single-left-sidebar'}`} element={<BlogSingleOne />}/>
          <Route exact path={`${process.env.PUBLIC_URL + '/blog-single-right-sidebar'}`} element={<BlogSingleTwo />}/>
          <Route path='*' element={<Error/>}/>
        </Routes>
    </Router>
  );
}

export default App;
